// Affärsområdet Foto — sidkarta, orter och kontaktperson.
// Sanningskälla för navigation, sitemap och internlänkar.

export const PHOTOGRAPHER = {
  name: "Fenny",
  role: "Fototeam",
  email: "hey@fenny.se",
  bio: "Kontakta Fenny om fotografering när tjänsten åter öppnar.",
} as const;

export interface FotoService {
  slug: string;
  path: string;
  label: string;
  nav: string;
  desc: string;
}

export const fotoServices: FotoService[] = [
  {
    slug: "foretagsfotografering",
    path: "/foto/foretagsfotografering",
    label: "Företagsfotografering",
    nav: "Företagsfotografering",
    desc: "Hela bildbehovet för ett bolag — porträtt, miljö, kampanj och event.",
  },
  {
    slug: "foretagsportratt",
    path: "/foto/foretagsportratt",
    label: "Företagsporträtt",
    nav: "Företagsporträtt & headshots",
    desc: "Enhetliga porträtt till sajt, LinkedIn och pressrum.",
  },
  {
    slug: "kampanjfoto",
    path: "/foto/kampanjfoto",
    label: "Kampanjfoto",
    nav: "Kampanjfoto",
    desc: "Bildmanér för kampanj, annons och varumärke.",
  },
  {
    slug: "eventfoto",
    path: "/foto/eventfoto",
    label: "Eventfoto",
    nav: "Eventfoto",
    desc: "Konferens, mässa och företagsevent dokumenterat samma dag.",
  },
  {
    slug: "produktfoto",
    path: "/foto/produktfoto",
    label: "Produktfoto",
    nav: "Produktfoto",
    desc: "Produktbilder för e-handel, katalog och annons.",
  },
  {
    slug: "studiofotografering",
    path: "/foto/studiofotografering",
    label: "Studiofotografering",
    nav: "Studiofotografering",
    desc: "Kontrollerat ljus, ren bakgrund och hög produktionstakt.",
  },
  {
    slug: "foto-och-film",
    path: "/foto/foto-och-film",
    label: "Foto och film samtidigt",
    nav: "Foto + film",
    desc: "Ett inspelningstillfälle som ger både rörligt och stillbilder.",
  },
  {
    slug: "vad-kostar-en-fotograf",
    path: "/foto/vad-kostar-en-fotograf",
    label: "Vad kostar en fotograf?",
    nav: "Vad kostar en fotograf?",
    desc: "Kostnadsdrivare, offertlogik och vad som påverkar priset.",
  },
];

export interface FotoCity {
  slug: string;
  path: string;
  city: string;
  region: string;
  intro: string;
  areas: string[];
}

export const fotoCities: FotoCity[] = [
  {
    slug: "stockholm",
    path: "/foto/stockholm",
    city: "Stockholm",
    region: "Stockholms län",
    intro:
      "Studio i Stockholm och fotografering på plats i era lokaler — från enskilda porträtt till hela ledningsgrupper och kampanjproduktioner.",
    areas: ["Innerstaden", "Solna", "Kista", "Sickla", "Södermalm", "Arlanda-området"],
  },
  {
    slug: "goteborg",
    path: "/foto/goteborg",
    city: "Göteborg",
    region: "Västra Götaland",
    intro:
      "Fotograf i Göteborg för företagsporträtt, kampanjbilder och event — i studio, på kontoret eller ute i produktionen.",
    areas: ["Centrum", "Lindholmen", "Gårda", "Mölndal", "Hisingen", "Landvetter"],
  },
  {
    slug: "malmo",
    path: "/foto/malmo",
    city: "Malmö",
    region: "Skåne län",
    intro:
      "Fotografering i Malmö och Öresundsregionen — porträtt, kampanj och event för bolag som vill ha ett tydligt bildmanér.",
    areas: ["Västra hamnen", "Hyllie", "Centrum", "Lund", "Helsingborg", "Köpenhamn"],
  },
  {
    slug: "uppsala",
    path: "/foto/uppsala",
    city: "Uppsala",
    region: "Uppsala län",
    intro:
      "Fotograf i Uppsala för life science, techbolag och offentlig verksamhet — porträtt, miljöbilder och event.",
    areas: ["Centrum", "Boländerna", "Ultuna", "Fyrislund", "Knivsta"],
  },
  {
    slug: "vasteras",
    path: "/foto/vasteras",
    city: "Västerås",
    region: "Västmanlands län",
    intro:
      "Fotografering i Västerås och Mälardalen — industri, verkstad och tjänstebolag med behov av porträtt och kampanjbilder.",
    areas: ["Centrum", "Finnslätten", "Hacksta", "Erikslund", "Eskilstuna", "Enköping"],
  },
  {
    slug: "linkoping",
    path: "/foto/linkoping",
    city: "Linköping",
    region: "Östergötlands län",
    intro:
      "Fotograf i Linköping för tech, försvarsindustri och universitetsnära bolag — porträtt, miljöbilder och kampanj.",
    areas: ["Centrum", "Mjärdevi", "Tornby", "Vallastaden", "Linghem", "Mantorp"],
  },
  {
    slug: "norrkoping",
    path: "/foto/norrkoping",
    city: "Norrköping",
    region: "Östergötlands län",
    intro:
      "Fotografering i Norrköping för logistik, industri och besöksnäring — porträtt, produktbilder och event.",
    areas: ["Centrum", "Industrilandskapet", "Ingelsta", "Händelö", "Söderköping", "Finspång"],
  },
  {
    slug: "orebro",
    path: "/foto/orebro",
    city: "Örebro",
    region: "Örebro län",
    intro:
      "Fotograf i Örebro för handel, logistik och offentlig verksamhet — enhetliga porträtt och kampanjbilder.",
    areas: ["Centrum", "Aspholmen", "Marieberg", "Berglunda", "Kumla", "Hallsberg"],
  },
  {
    slug: "helsingborg",
    path: "/foto/helsingborg",
    city: "Helsingborg",
    region: "Skåne län",
    intro:
      "Fotografering i Helsingborg och nordvästra Skåne — porträtt, produktfoto och kampanj för handel och industri.",
    areas: ["Centrum", "Berga", "Väla", "Ramlösa", "Ängelholm", "Landskrona"],
  },
  {
    slug: "lund",
    path: "/foto/lund",
    city: "Lund",
    region: "Skåne län",
    intro:
      "Fotograf i Lund för life science, forskning och techbolag — porträtt, labbmiljö och kampanjbilder.",
    areas: ["Centrum", "Ideon", "Brunnshög", "Gastelyckan", "Staffanstorp", "Malmö"],
  },
  {
    slug: "jonkoping",
    path: "/foto/jonkoping",
    city: "Jönköping",
    region: "Jönköpings län",
    intro:
      "Fotografering i Jönköping och Gnosjöregionen — industri, tillverkning och handel med behov av bild.",
    areas: ["Centrum", "A6", "Torsvik", "Huskvarna", "Värnamo", "Gnosjö"],
  },
  {
    slug: "boras",
    path: "/foto/boras",
    city: "Borås",
    region: "Västra Götaland",
    intro:
      "Fotograf i Borås för textil, e-handel och logistik — produktbilder, porträtt och kampanjfoto.",
    areas: ["Centrum", "Viared", "Knalleland", "Ulricehamn", "Alingsås", "Göteborg"],
  },
  {
    slug: "umea",
    path: "/foto/umea",
    city: "Umeå",
    region: "Västerbottens län",
    intro:
      "Fotografering i Umeå för universitet, offentlig sektor och norrländska tillväxtbolag.",
    areas: ["Centrum", "Universitetsområdet", "Ersboda", "Teg", "Holmsund", "Skellefteå"],
  },
  {
    slug: "lulea",
    path: "/foto/lulea",
    city: "Luleå",
    region: "Norrbottens län",
    intro:
      "Fotograf i Luleå och Norrbotten — industri, grön omställning och teknikbolag i norra Sverige.",
    areas: ["Centrum", "Storheden", "Porsön", "Boden", "Piteå", "Gällivare"],
  },
  {
    slug: "sundsvall",
    path: "/foto/sundsvall",
    city: "Sundsvall",
    region: "Västernorrlands län",
    intro:
      "Fotografering i Sundsvall för bank, skogsindustri och tjänstebolag längs Norrlandskusten.",
    areas: ["Centrum", "Birsta", "Timrå", "Härnösand", "Örnsköldsvik", "Ånge"],
  },
  {
    slug: "gavle",
    path: "/foto/gavle",
    city: "Gävle",
    region: "Gävleborgs län",
    intro:
      "Fotograf i Gävle för industri, logistik och offentlig verksamhet i Gästrikland.",
    areas: ["Centrum", "Sätra", "Näringen", "Valbo", "Sandviken", "Söderhamn"],
  },
  {
    slug: "eskilstuna",
    path: "/foto/eskilstuna",
    city: "Eskilstuna",
    region: "Södermanlands län",
    intro:
      "Fotografering i Eskilstuna och Sörmland — verkstad, logistik och tjänstebolag i Mälardalen.",
    areas: ["Centrum", "Munktellstaden", "Folkesta", "Torshälla", "Strängnäs", "Katrineholm"],
  },
  {
    slug: "karlstad",
    path: "/foto/karlstad",
    city: "Karlstad",
    region: "Värmlands län",
    intro:
      "Fotograf i Karlstad för pappersindustri, handel och tjänstebolag i Värmland.",
    areas: ["Centrum", "Välsviken", "Bergvik", "Hammarö", "Kristinehamn", "Arvika"],
  },
  {
    slug: "vaxjo",
    path: "/foto/vaxjo",
    city: "Växjö",
    region: "Kronobergs län",
    intro:
      "Fotografering i Växjö och Småland — trä, tillverkning och universitetsnära verksamheter.",
    areas: ["Centrum", "Nylanda", "Räppe", "Alvesta", "Ljungby", "Kalmar"],
  },
  {
    slug: "halmstad",
    path: "/foto/halmstad",
    city: "Halmstad",
    region: "Hallands län",
    intro:
      "Fotograf i Halmstad och Halland — industri, besöksnäring och handel längs västkusten.",
    areas: ["Centrum", "Flygstaden", "Kistinge", "Laholm", "Falkenberg", "Varberg"],
  },
];


export const FOTO_PATHS = [
  "/foto",
  ...fotoServices.map((s) => s.path),
  ...fotoCities.map((c) => c.path),
];
